import {useQuery} from 'react-query'
import {ComplaintEditModalForm} from './ComplaintEditModalForm'
// import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getComplaintById} from '../core/_requests'
import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'

const ComplaintEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const dataresponse = {name:"demo"}
  const {
    isLoading,
    data: complaint,
    error,
  } = useQuery(
    `${QUERIES.COMPLAINTS_LIST}-complaint-${itemIdForUpdate}`,
    () => {
      return getComplaintById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        // setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )


  if (!itemIdForUpdate) {
    return <ComplaintEditModalForm isComplaintLoading={false} complaint={{id: undefined}} />
  }

  if (itemIdForUpdate) {
    return <ComplaintEditModalForm isComplaintLoading={false} complaint={dataresponse} />
  }

  return null
}

export {ComplaintEditModalFormWrapper}
